import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";

// Reject a request, with a reason the bidder sees. Unless "Don't allow
// another request" is ticked he may ask once more.
const RejectDialog = ({ request, onClose, onReject, saving }) => {
  const [reason, setReason] = useState("");
  const [blockAnother, setBlockAnother] = useState(false);

  useEffect(() => {
    setReason("");
    setBlockAnother(false);
  }, [request]);

  const name = request
    ? [request.user?.firstName, request.user?.lastName].filter(Boolean).join(" ")
    : "";

  return (
    <Dialog open={Boolean(request)} onClose={saving ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        Reject {name}
        {request?.company?.companyName ? ` (${request.company.companyName})` : ""}?
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ color: "#4B5563", mb: 2 }}>
          He will see this on the auction page and on his My requests page.
        </Typography>
        <TextField
          label="Reason (optional, shown to the bidder)"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          inputProps={{ maxLength: 500 }}
          multiline
          minRows={3}
          fullWidth
        />
        <FormControlLabel
          sx={{ mt: 2, alignItems: "flex-start" }}
          control={
            <Checkbox
              checked={blockAnother}
              onChange={(event) => setBlockAnother(event.target.checked)}
              sx={{ pt: 0.5 }}
            />
          }
          label={
            <>
              <Typography sx={{ fontWeight: 500 }}>Don't allow another request</Typography>
              <Typography variant="body2" sx={{ color: "#4B5563" }}>
                Unticked: he may ask once more for this auction.
              </Typography>
            </>
          }
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() =>
            onReject({ reason: reason.trim(), allowAnotherRequest: !blockAnother })
          }
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ backgroundColor: "#B4321A", borderRadius: 0, "&:hover": { backgroundColor: "#962914" } }}
        >
          Reject request
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RejectDialog;
